import { Row } from 'antd';
import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';

import registracePotvrzeniApi from 'services/registracePotvrzeni';

import routePathEnum from 'enums/routePathEnum';

const RegistracePotvrzeni: React.FC = () => {
    const { tokenURL } = useParams<{ tokenURL: string }>();
    const [resolve, setResolve] = useState<number>();
    useEffect(() => {
        registracePotvrzeniApi(tokenURL!)
            .then((resp: AxiosResponse) => setResolve(resp.status))
            .catch((err: any) => setResolve(err.request.status));
    }, [tokenURL]);

    return (
        <AuthWrapper>
            {resolve === 200 && (
                <>
                    <Row>
                        <Title text="EMP_AKTIVACE_OK" level={3} />
                    </Row>
                    <Row>
                        <AnchorComponent link={true} to={routePathEnum.LOGIN_ROZCESTNIK}>
                            <ButtonComponent buttontext="PRIHLASIT_SE" id="loginBtn" />
                        </AnchorComponent>
                    </Row>
                </>
            )}
            {resolve === 401 && <Title text="EMP_AKTIVACE_401" level={3} />}
        </AuthWrapper>
    );
};

export default RegistracePotvrzeni;
